import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';

import environment from './libs/environment';

import Filters from './containers/filters';
import Posts from './containers/posts';

// actions
import { peopleDataLoaded, postUpdated } from './actions';

import 'bootstrap/dist/css/bootstrap.css';
import './App.scss';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.getData = this.getData.bind(this);
  }

  componentDidMount = () => {
    this.getData();
  };

  getData = () => {
    axios
      .get(`${environment.domain}${environment.dataPath}/library.json`)
      .then(response => {
        // handle success
        this.props.peopleDataLoaded(true, response.data);
      })
      .catch(error => {
        // handle error
        console.log(error);
      });
  };

  render() {
    if (this.props.dataLoaded) {
      return (
        <section>
          <div className="filters filters d-flex flex-wrap bg-blue">
            <div className="container">
              <Filters />
            </div>
          </div>

          <div className="container posts-container">
            <Posts />
          </div>
        </section>
      );
    } else {
      return null;
    }
  }
}

App.propTypes = {};

const mapStateToProps = state => {
  return {
    dataLoaded: state.postData.dataLoaded
  };
};

const mapDispatchToProps = dispatch => {
  return {
    peopleDataLoaded: (loaded, data) => dispatch(peopleDataLoaded(loaded, data)),
    postUpdated: (sortBy, data) => dispatch(postUpdated(sortBy, data))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
